import React, { useState, useEffect, useRef } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../styles/select-style'
import ApiService from '../../../services/ApiService'
import { MaterialType } from './types'
import { CertificateType } from '../../../pages/ClientPanel/Certificates/CreateCertificate'

type PropsType = {
  certificate: CertificateType,
  setCertificate: React.Dispatch<React.SetStateAction<CertificateType>>,
  itsOurs: boolean
}

const SelectMaterialInCertificate:React.FC<PropsType> = ({certificate, setCertificate, itsOurs}) => {
  const [ items, setItems ] = useState<Array<MaterialType>>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const [ selectedIndex, setSelectedIndex ] = useState(0)

  useEffect(() => {
    setInputItem(certificate.startingMaterial || '')
  }, [certificate.startingMaterial])
  
  useEffect(() => {
    setSelectedIndex(0)
    const handle = setTimeout(() => {
      ApiService.certificates.getMaterials({ query: inputItem })
        .then((response: any) => {
          if(response.data) setItems(response.data)
        })
        .catch((error: any) => {
          console.log(error)
        })
    }, 300)

    return () => clearTimeout(handle)
  }, [inputItem])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
  }

  const handleSelectItem = (item: MaterialType) => {
    setInputItem(item.description)
    setShowOptions(false)
    setCertificate((prev: CertificateType) => ({
      ...prev,
      startingMaterial: item.description,
      heatNumber: item.heatNumber ? {
        id: item.heatNumber.id, 
        heatNumber: item.heatNumber.heatNumber, 
        originCertificateId: item.heatNumber.originCertificateId
      } : {id: 0, heatNumber: '', originCertificateId: undefined}
    }))
  }

  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < items.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter' && items[selectedIndex]) handleSelectItem(items[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }
  
  return(
    <InputDiv>
      <Label>Material de partida</Label>
      <Input 
        ref={inputRef}
        type='text' 
        placeholder={itsOurs ? 'Selecione uma M.P.' : 'Selecione'}
        value={inputItem}
        onFocus={() => setShowOptions(true)}
        onChange={handleChangeInput}
        onKeyDown={handleSetOptionByKey}
        disabled={itsOurs}
      />
      {showOptions && 
        <SearchOptions ref={optionsRef}>
          {items.map((m, index) => 
            <Option 
              key={index}
              onClick={() => handleSelectItem(m)}
              isSelected={index === selectedIndex}
            >
              {m.description}
            </Option>
          )}
        </SearchOptions>
      }
    </InputDiv>
  )
}

export default SelectMaterialInCertificate

